import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SessionCompanyModel } from '../../app-lite/sessions/models/session.company';
import { SessionModel }        from '../../app-lite/sessions/models/session';
import { SessionService }      from '../../app-lite/sessions/session.service';
import { VehicleModel }        from '../../app-lite/vehicles/models/vehicle';

@Component({
  template: require('./customer.vehicle.actions.component.html')
})
export class CustomerVehicleActionsComponent {
  @Input() record: VehicleModel;

  @Output() onAddVVGarageClick   : EventEmitter<VehicleModel> = new EventEmitter();
  @Output() onEditClick          : EventEmitter<VehicleModel> = new EventEmitter();
  @Output() onEventClick         : EventEmitter<VehicleModel> = new EventEmitter();
  @Output() onInvoiceClick       : EventEmitter<VehicleModel> = new EventEmitter();
  @Output() onRemoveVVGarageClick: EventEmitter<VehicleModel> = new EventEmitter();

  constructor (
    public sessionService: SessionService
  ) {}

  get company () : SessionCompanyModel { return this.sessionService.company(); }

  get session () : SessionModel { return this.sessionService.base(); }
}